import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { SoundProvider } from "@/context/SoundContext";
import { AuthProvider } from "@/context/AuthContext";

// Remove static no-JS fallback <head> metadata the instant JS runs, BEFORE
// react-helmet-async injects route-specific tags — prevents duplicate/conflicting
// description/canonical/robots/OG/Twitter in the rendered DOM.
if (typeof document !== "undefined") {
  document.querySelectorAll("head [data-fallback]").forEach((el) => el.remove());
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <SoundProvider>
          <BrowserRouter>
            <AuthProvider>
              <App />
            </AuthProvider>
          </BrowserRouter>
        </SoundProvider>
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>,
);
